import { Box, Paper, Typography } from "@mui/material";
import React from "react";
import { useTheme } from "../hooks";
import { getContrastTextColor, toSurfaceTint } from "../utils/colorManager";

interface StepContainerProps {
  title: string;
  description: string;
  children?: React.ReactNode;
}

const StepContainer: React.FC<StepContainerProps> = ({
  title,
  description,
  children,
}) => {
  const { theme } = useTheme();
  const surface = toSurfaceTint(theme.color_secondary);
  return (
    <Paper
      sx={{
        width: "33.33%",
        bgcolor: surface,
        borderLeft: 4,
        borderColor: theme.color_primary,
        p: 2,
        mb: 3,
        borderRadius: 1,
      }}
    >
      <Typography
        variant="h6"
        color={getContrastTextColor(surface)}
        fontWeight="bold"
        mb={0.5}
      >
        {title}
      </Typography>
      <Typography
        variant="body2"
        mb={1}
        color={getContrastTextColor(surface)}
      >
        {description}
      </Typography>
      {children && <Box>{children}</Box>}
    </Paper>
  );
};

export default StepContainer;
